import React, { PropsWithChildren } from 'react'

import * as S from './styles'
import { Image } from '../image'
import { Text } from '../text'
import { useServiceDetail } from '@/containers/serviceDetail/useServiceDetail'
import { useIsVisibleElement } from '@/hooks'
import { DefaultImage } from '@/service/types'

export type ServiceDetailCardProps = PropsWithChildren<{
  firstTitle: string | null
  firstSubtitle: string | null
  firstDescription: string | null
  secondTitle: string | null
  secondSubtitle: string | null
  secondDescription: string | null
  image: DefaultImage | null
  invert: boolean
}>

export const ServiceDetailCard: React.FC<ServiceDetailCardProps> = ({
  firstTitle,
  firstDescription,
  secondSubtitle,
  firstSubtitle,
  secondDescription,
  secondTitle,
  image,
  invert = false,
}) => {
  const { element, elementVisible } = useIsVisibleElement()
  const secondEmpty = !secondTitle && !secondSubtitle && !secondDescription
  const { fontSizes } = useServiceDetail()

  return (
    <S.Container invert={invert}>
      <S.Column>
        <S.TitleContainer>
          <div className="group-text">
            <Text size={fontSizes.titleDetail} color="primary">
              {firstTitle}
            </Text>
            <Text size={fontSizes.subtitleDetail} color="white">
              {firstSubtitle}
            </Text>
            <Text
              size={fontSizes.descriptionDetail}
              color="white"
              className="description"
            >
              {firstDescription}
            </Text>
          </div>
          {!secondEmpty && (
            <div className="group-text">
              {secondTitle && (
                <Text size={fontSizes.titleDetail} color="primary">
                  {secondTitle}
                </Text>
              )}
              {secondSubtitle && (
                <Text size={fontSizes.subtitleDetail} color="white">
                  {secondSubtitle}
                </Text>
              )}
              {secondDescription && (
                <Text
                  size={fontSizes.descriptionDetail}
                  color="white"
                  className="description"
                >
                  {secondDescription}
                </Text>
              )}
            </div>
          )}
        </S.TitleContainer>
      </S.Column>
      {image && (
        <S.Column ref={element}>
          <S.SlideInContainer
            className={`slide ${elementVisible ? 'active' : ''}`}
          >
            <Image
              src={image.url}
              alt={image.alternativeText}
              fileName={image.name}
              fill
            />
          </S.SlideInContainer>
        </S.Column>
      )}
    </S.Container>
  )
}
